const targets = {
  'project-edit': (id) => ({ name: 'build', params: { id } }),
  'project-preview': (id) => ({ name: 'platform-project-preview', params: { id } }),
  'component-edit': (id) => ({ name: 'component-resource-edit', params: { id } }),
  'template-component-edit': (id) => ({ name: 'template-component-edit', params: { id } }),
  'template-page-edit': (id) => ({ name: 'template-page-edit', params: { id } }),
  'template-project-edit': (id) => ({ name: 'template-project-edit', params: { id } }),
  'template-page-preview': (id) => ({ name: 'template-page-preview', params: { id } }),
  'template-project-preview': (id) => ({ name: 'template-project-preview', params: { id } })
}
export function platformEditorTarget(target, id) {
  if (
    !Object.prototype.hasOwnProperty.call(targets, target) ||
    typeof id !== 'string' ||
    !/^[A-Za-z0-9_-]{1,64}$/.test(id)
  )
    throw new Error('平台编辑目标无效')
  return targets[target](id)
}
export function platformEditorOrigin(value) {
  if (typeof value !== 'string') throw new Error('平台来源无效')
  const url = new URL(value)
  if (
    !['https:', 'http:'].includes(url.protocol) ||
    url.origin !== value ||
    url.username ||
    url.password
  )
    throw new Error('平台来源无效')
  return url.origin
}
